module.exports = __webpack_public_path__ + "img/sieckFinesseRelease2.9b4dfd1d.png";